import * as React from 'react';
import type { ConnectedProps } from 'react-redux';
import { connect } from 'react-redux';
import { compose } from 'redux';

import { useScheduleBoardModals } from 'af-root/hooks/useScheduleBoardModal';
import RelatedWorkOrders from 'af-root/scenes/Company/Resources/Shared/RelatedWorkOrders';

import TableNameEnum from 'ab-enums/tableName.enum';

import type { TableQuery } from 'ab-common/dataStructures/tableQuery';

import { Button } from '@acceligentllc/storybook';

import CustomModal from 'af-components/CustomModal';

import * as EquipmentActions from 'af-actions/equipment';

import styles from './styles.module.scss';

interface OwnProps {
	companyName: string;
}

type Props = OwnProps & ConnectedProps<typeof connector>;

const EquipmentWorkOrderHistoryModal: React.FC<Props> = (props: Props) => {
	const {
		companyName,
		findRelatedWorkOrdersTable,
	} = props;

	const { equipment, showEquipmentWOHistoryModal, setEquipmentWOHistoryModalVisibility, setEquipmentModalVisibility } = useScheduleBoardModals();

	const fetchWorkOrders = React.useCallback((tableRequestModel: TableQuery, startDate: Date, endDate: Date) => {
		if (!equipment?.id) {
			throw new Error('Missing equipment data');
		}
		return findRelatedWorkOrdersTable(equipment.id, tableRequestModel, startDate, endDate);
	}, [equipment?.id, findRelatedWorkOrdersTable]);

	const closeModal = React.useCallback(() => {
		setEquipmentWOHistoryModalVisibility(false);
		setEquipmentModalVisibility(true);
	}, [setEquipmentWOHistoryModalVisibility, setEquipmentModalVisibility]);

	if (!equipment) {
		return null;
	}

	const { name, specification, code } = equipment;

	const baseClassName = 'equipment-wo-history-modal';
	const headerClassName = `${baseClassName}__big-header`;
	const headerLeft = `${baseClassName}__big-header-left`;
	const headerRight = `${baseClassName}__big-header-right`;
	const iconClassName = 'header-close-icon';
	const modalBody = 'modal-body';
	const titleSpecification = `${baseClassName}__title-equipment-specification`;

	return (
		<>
			<CustomModal
				className={styles[baseClassName]}
				closeModal={closeModal}
				modalStyle="info"
				showModal={showEquipmentWOHistoryModal}
			>
				<CustomModal.Header className={styles[headerClassName]}>
					<div className={`${styles[headerLeft]} `}>
						<span>{` WORK ORDER HISTORY | ${name} `}</span>
						{specification
							? <span className={`${styles[titleSpecification]} `}> {specification}</span>
							: null
						}
					</div>
					<div className={`${styles[headerRight]} `}>
						<span
							className={`icon-close ${styles[iconClassName]}`}
							onClick={closeModal}
						/>
					</div>
				</CustomModal.Header>
				<CustomModal.Body className={`${styles[modalBody]} `}>
					<RelatedWorkOrders
						companyName={companyName}
						csvName={`${companyName}_${code}_work_orders.csv`}
						fetchWorkOrders={fetchWorkOrders}
						tableName={TableNameEnum.EQUIPMENT_WORK_ORDERS}
					/>
				</CustomModal.Body>
				<CustomModal.Footer>
					<Button
						label="Close"
						onClick={closeModal}
						style="secondary"
					/>
				</CustomModal.Footer>
			</CustomModal>
		</>
	);
};

const mapDispatchToProps = () => {
	return {
		findRelatedWorkOrdersTable: EquipmentActions.findRelatedWorkOrdersTable,
	};
};

const connector = connect(null, mapDispatchToProps());

const enhance = compose<React.ComponentType<OwnProps>>(
	React.memo,
	connector
);

export default enhance(EquipmentWorkOrderHistoryModal);
